import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgArrowDown = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M6.328 14.55a.785.785 0 0 0-1.1 0 .76.76 0 0 0 0 1.086l6.222 6.14a.78.78 0 0 0 .848.166.8.8 0 0 0 .252-.167l6.222-6.14a.76.76 0 0 0 0-1.085.785.785 0 0 0-1.1 0l-4.894 4.83V2.767A.773.773 0 0 0 12 2a.773.773 0 0 0-.778.767V19.38z"
      />
    </svg>
  );
};
export default SvgArrowDown;
